import dayjs from 'dayjs'
import { PdPayload } from './types'
import { DatetimeString } from '@/types/utils'

export const createNewPdPayload = (
  datetime = dayjs().format('YYYY-MM-DD HH:mm:ss') as DatetimeString
): PdPayload => ({
  entryDatetime: datetime,
  wasteFluid: null,
  wasteFluidImage: null,
  hasWasteFluidImage: null,
  wasteFluidImageFileName: null,
  exitsite: null,
  exitsiteImage: null,
  hasExitsiteImage: null,
  exitsiteImageFileName: null,
  swelling: null,
  drainVolume: null,
  infusionVolume: null,
  waterRemoval: null,
  weight: null,
  urineVolume: null,
  waterDrinkingVolume: null
})
